export default __webpack_public_path__ + "static/media/csk_grap_chart.bdee8e31.jpg";